module.exports = {
    SINGLE: 'SINGLE',
    PIEZO_NETWORK: 'PIEZO_NETWORK',
    QUALITO_NETWORK: 'QUALITO_NETWORK',
}